import type { SearchParams } from 'meilisearch/dist/types/types/types';
import type { SearchResult } from '~/types/fulltextSearch';

export type FulltextSearchOptions = {
    limit?: number;
    filter?: string[];
    indexName?: string;
    offset?: number;
    attributesToCrop?: string[];
    cropLength?: number;
    attributesToHighlight?: string[];
    highlightPreTag?: string;
    highlightPostTag?: string;
}

export type FulltextSearchResponse = {
    estimatedTotalHits: number;
    hits: SearchResult[];
    offset: number;
}

const DEFAULT_LIMIT = 10;

export async function fulltextSearch(
    query: string,
    indexName: string,
    options: FulltextSearchOptions = {}
): Promise<FulltextSearchResponse> {
    const result = {
        estimatedTotalHits: 0,
        hits: [] as SearchResult[],
        offset: 0
    };

    if (!query.trim()) {
        return result;
    }

    try {
        const { search } = useMeiliSearch(indexName);

        const searchParams: SearchParams = {
            limit: options.limit || DEFAULT_LIMIT,
            filter: options.filter || [],
            offset: options.offset || 0,
        };
        if (options.attributesToCrop) {
            searchParams.attributesToCrop = options.attributesToCrop;
        }
        if (options.cropLength) {
            searchParams.cropLength = options.cropLength;
        }
        if (options.attributesToHighlight) {
            searchParams.attributesToHighlight = options.attributesToHighlight;
            searchParams.highlightPreTag = options.highlightPreTag || '<strong>';
            searchParams.highlightPostTag = options.highlightPostTag || '</strong>';
        }

        const response = await search(query, searchParams);
        result.estimatedTotalHits = response.estimatedTotalHits;
        result.hits = response.hits as SearchResult[];
        result.offset = response.offset;
        return result;
    } catch (error) {
        return result;
    }
} 
